import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 md:py-12 bg-green-50 border-y border-green-100" data-id="element-144">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-145">
        <div className="inline-flex items-center justify-center w-12 h-12 md:w-20 md:h-20 bg-green-100 rounded-full mb-3 md:mb-4" data-id="element-146">
          <ShieldCheck className="w-7 h-7 md:w-12 md:h-12 text-green-600" data-id="element-147" />
        </div>
        <h2 className="font-heading text-lg md:text-3xl text-green-900 mb-1 md:mb-2" data-id="element-148">
          7 DÍAS GARANTÍA TOTAL
        </h2>
        <h3 className="text-sm md:text-xl font-bold text-green-800 mb-1 md:mb-2" data-id="element-149">
          Probalo o te devolvemos el 100%
        </h3>
        <p className="text-green-700 text-xs md:text-base" data-id="element-150">
          Sin preguntas, sin formularios, sin drama.
        </p>
      </div>
    </section>;
}